import Vue from "vue";
import App from "./App";
import router from "./router";
import Vuex from "vuex";
import store from "./vuex/";
//import './config/rem'
//import flexible from './config/flexible'
import fastclick from "fastclick";
import "vue2-animate/dist/vue2-animate.css";
import "mint-ui/lib/style.css";
import MintUI from "mint-ui";
import * as _ from "lodash";
import {
  MessageBox
} from "mint-ui";
import VueLazyload from "vue-lazyload";

// import {
//   iGetSessionKey,
//   iGetApiToken
// } from "./api/api.js";
// import {
//   _webapp
// } from "./config/hook.js";
import axios from "axios";
Vue.prototype.intAxios = axios;

import _axios from './api/index';
Vue.prototype.$axios = _axios;
Vue.prototype.$apiUrl = config.apiUrl;
Vue.prototype.$fileUrl = config.fileUrl;

// import axios from "axios";
// Vue.prototype.$axios = axios;

Vue.use(VueLazyload, {
  loading: require("./assets/images/default.gif"),
});
fastclick.attach(document.body);
Vue.use(Vuex);
Vue.use(MintUI);
Vue.config.productionTip = false;

import vuescroll from "vuescroll";
import "vuescroll/dist/vuescroll.css";
Vue.use(vuescroll);

import uploader from "vue-simple-uploader";
Vue.use(uploader);

import "./components/Loading/index.css";
import Loading from "./components/Loading/index";
Vue.use(Loading);

import VideoPlayer from "vue-video-player";
require("video.js/dist/video-js.css");
require("vue-video-player/src/custom-theme.css");
Vue.use(VideoPlayer);

import vueSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
Vue.use(vueSwiper);

// iGetApiToken(function (apiToken) {
//   //console.log(apiToken);
//   if (apiToken) {
//     iGetSessionKey(function (sessionKey) {
//       if (sessionKey === false) {
//         MessageBox({
//           title: "友情提示",
//           message: "获取用户信息失败，可能是登陆超时或在其他设备中登陆，点击确认将为您跳转至登陆页面。",
//           showCancelButton: false,
//           closeOnClickModal: false,
//         }).then((action) => {
//           //_webapp.nativeLogin();
//         });
//       }
//     });
//   } else {
//     MessageBox({
//       title: "友情提示",
//       message: "很抱歉，系统可能出现了点问题，请您关闭APP（需后台任务清除）后重新尝试。",
//       showCancelButton: false,
//       closeOnClickModal: false,
//     }).then((action) => {
//       //_webapp.nativeLogin();
//     });
//   }
// });

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");



// WEBPACK FOOTER //
// ./src/main.js